// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Tooltip{z-index:1500;font-family:var(--tooltip-font-family)}.Tooltip.Popup2::before{content:none}", ""]);
// Exports
module.exports = exports;
